import { ActionTypes, Actions } from '../actions/dco.action';
import * as moment from 'moment';

export interface State {
    offerDays: number;
    cutOffDate: moment.Moment;
}

const initialState: State = {
    offerDays: 30,
    cutOffDate: moment(),
};

export function reducer(state = initialState, action: Actions): State {
    switch (action.type) {
        case ActionTypes.SET_CUTOFF_DATE: {
            return { ...state, cutOffDate: action.payload.date };
        }
        case ActionTypes.SET_OFFER_DAYS: {
            return { ...state, offerDays: action.payload.days };
        }
        case ActionTypes.RESET_STATE: {
            return initialState;
        }
        default: {
            return state;
        }
    }
}
